import React from 'react'
import {Tag, Tooltip} from 'antd'
import humanizeTime from '../../../helpers/humanizeTime'

const STATUS_COLOR = {
    completed: 'green',
    created: 'default',
}

const QUEUE_COLOR = {
    pushed: 'green',
    pushing: 'orange',
}

function JobCrawlersList({data, loading}) {
    return (
        <table className="table table-hover">
            <thead>
                <tr>
                    <th>ID</th>
                    <th>Source</th>
                    <th>Status</th>
                    <th>Queue</th>
                    <th>Total</th>
                    <th>Updated</th>
                    <th>Failed</th>
                    <th>Unknown</th>
                    <th>
                        <Tooltip title="Băng thông ước tính (cận dưới), không dùng đối soát hóa đơn">
                            Bandwidth (MB)
                        </Tooltip>
                    </th>
                    <th>Start At</th>
                    <th>Created At</th>
                </tr>
            </thead>
            <tbody>
                {!loading && data.length === 0 && (
                    <tr>
                        <td colSpan={11}>No record</td>
                    </tr>
                )}
                {data.map(job => (
                    <tr key={job._id}>
                        <td><code>{job._id}</code></td>
                        <td>{job.source}</td>
                        <td>
                            <Tag color={STATUS_COLOR[job.status] || 'default'}>
                                {job.status}
                            </Tag>
                        </td>
                        <td>
                            <Tag color={QUEUE_COLOR[job.status_queue] || 'default'}>
                                {job.status_queue}
                            </Tag>
                        </td>
                        <td>{job.trackings_total}</td>
                        <td>{job.trackings_updated}</td>
                        <td>{job.trackings_failed}</td>
                        <td>{job.trackings_unknown}</td>
                        <td>
                            {job.bandwidth_mb !== null && job.bandwidth_mb !== undefined
                                ? Number(job.bandwidth_mb).toFixed(2)
                                : ''}
                        </td>
                        <td>{job.start_at ? humanizeTime(job.start_at) : ''}</td>
                        <td>{job.created_at ? humanizeTime(job.created_at) : ''}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default JobCrawlersList
